import {
  useCreateRoleMutation,
  useDeleteRoleMutation,
  useGetAllRolesMutation,
  useSelectRoleMutation,
  useUpdateRoleMutation,
} from "../store/services/rolesQuery";

export const useRoles = () => {
  const [
    getAllRoles,
    {
      data: allRolesData,
      isLoading: allRolesIsLoading,
      isError: allRolesIsError,
      error: allRolesError,
      isSuccess: allRolesSuccess,
    },
  ] = useGetAllRolesMutation();

  const [
    createRoleFunc,
    {
      data: createRoleData,
      isLoading: createRoleIsLading,
      isError: createRoleIsError,
      error: createRoleError,
      isSuccess: createRoleSuccess,
    },
  ] = useCreateRoleMutation();

  const [
    getSelectedRoles,
    {
      data: selectedRoleData,
      isLoading: selectedRoleIsLoading,
      isError: selectedRoleIsError,
      error: selectedRoleError,
      isSuccess: selectedRoleSuccess,
    },
  ] = useSelectRoleMutation();

  const [
    deleteRole,
    {
      data: deleteRoleData,
      isLoading: deleteRoleIsLading,
      isError: deleteRoleIsError,
      error: deleteRoleError,
      isSuccess: deleteRoleSuccess,
    },
  ] = useDeleteRoleMutation();

  const [
    updateRole,
    {
      data: updateRoleData,
      isLoading: updateRoleIsLading,
      isError: updateRoleIsError,
      error: updateRoleError,
      isSuccess: updateRoleSuccess,
    },
  ] = useUpdateRoleMutation();

  return {
    getAllRoles,
    allRolesData,
    allRolesIsLoading,
    allRolesIsError,
    allRolesError,
    allRolesSuccess,
    createRoleFunc,
    createRoleData,
    createRoleIsLading,
    createRoleIsError,
    createRoleError,
    createRoleSuccess,
    getSelectedRoles,
    selectedRoleData,
    selectedRoleIsLoading,
    selectedRoleIsError,
    selectedRoleError,
    selectedRoleSuccess,
    deleteRole,
    deleteRoleData,
    deleteRoleIsLading,
    deleteRoleIsError,
    deleteRoleError,
    deleteRoleSuccess,
    updateRole,
    updateRoleData,
    updateRoleIsLading,
    updateRoleIsError,
    updateRoleError,
    updateRoleSuccess,
  };
};
